import { ErrorToastConfig } from "app/utils/ToastConstants";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { getSessionUserInformation } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { deleteLifeEventDetails, getLifeEventDetails, insertLogs } from "../../homepurchase.service";
import moment from "moment";
import { getSessionClientInformation } from "app/utils/utility.service";
import AddLifeEvents from "./AddLifeEvents";
const initialState = {
    name: "",
    plannedDate: "",
    completionDate: "",
    action: ""
  };
const LifeEvents = () => {

    const [searchParams] = useSearchParams();
    const [values, setValues] = useState(initialState);
    const clientId = searchParams.get("clientid");
    let sessionValues =
        clientId && clientId !== "null"
          ? getSessionClientInformation()
          : getSessionUserInformation();
    const clientInfo = getSessionClientInformation();
    if (clientInfo) {
      sessionValues = clientInfo;
    }
    const userId =
    clientId && clientId !== "null" ? clientId : sessionValues.id;
    const [title, setTitle] = useState("");
    const [lifeEventModal, setLifeEventModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [lifeEvents, setLifeEvents] = useState([]);
    const toast = useRef();
    const showSuccess = (message) => {
      toast.current.show(SuccessToastConfig(message));
    };
    const showError = (message) => {
      toast.current.show(ErrorToastConfig(message ? message : "Error"));
    };
  
    useEffect(() => {
      setIsLoading(true);

      setValues({
        ...values,
        userId: userId,
      });
      fetchLifeeventDetails();
    }, [lifeEventModal]);
    const renderLifeEventModal = () => (
      <AddLifeEvents
        lifeEventModal={lifeEventModal}
        handleLifeEventModal={handleLifeEventModal}
        title={title}
        values={values}
        setValues={setValues}
      />
    );
    const handleLifeEventModal = () => {
      if (!lifeEventModal) {
        const payload = {
          description: "Life Events",
        };
        insertLogs(payload);
      }
  
      setTitle("Add Life Event");
  
      setLifeEventModal(!lifeEventModal);
    };
    const fetchLifeeventDetails = async () => {
      let list = await getLifeEventDetails(sessionValues.id);
      if (list) {
        setIsLoading(false);
        if (list) {
          list.map((li, index) => (li.srNo = index + 1));
        }
        setLifeEvents(list);
      }
    };

      const planneddateTemplate = (rowData) => {
        const formattedDate = moment(rowData.plannedDate).format('MM-DD-YYYY');
        return <span>{formattedDate}</span>;
      };
      const comdateTemplate = (rowData) => {
        const formattedDate = moment(rowData.completionDate).format('MM-DD-YYYY');
        return <span>{formattedDate}</span>;
      };
    
    const setEditValues = (rowData) => {
      setTitle("Edit Event");
      setValues({
        ...values,
        id:rowData.id,
        eventname: rowData.eventname,
        plannedDate: rowData.plannedDate,
        completionDate: rowData.completionDate,
        notes:rowData.notes,
        plannedExpense:rowData.plannedExpense,
        selectedOption:rowData.selectedOption,
        frequency:rowData.frequency
      });
      setLifeEventModal(!lifeEventModal);
    };
      // Custom body template to render hyperlinks
  const linkTemplate = (rowData, options) => {
    return (
      <span
        style={{
          textAlign: "center",
       //   whiteSpace: "pre-line",
          cursor: "pointer",
        }}
        onClick={() => setEditValues(rowData)}
      >
        {rowData.eventname}
      </span>
    );
  };
    const actionTemplate = (rowData, options) => {
      const menu = React.createRef();
  
      const handleEdit = () => {
        setEditValues(rowData);
      };
  
      const handleDelete = async () => {
        const details = await deleteLifeEventDetails(rowData.id);
        if (details) {
          showSuccess("Life event deleted successfully");
          // insert settings value
          setIsLoading(false);
          setTimeout(() => {
            fetchLifeeventDetails();
          }, 1000);
        } else {
          showError("Error");
        }
      };
  
      const items = [
        { label: "Edit", command: handleEdit },
        { label: "Delete", command: handleDelete },
      ];
  
      return (
        <>
          <Menu model={items} popup ref={menu} />
  
          <i
            style={{ cursor: "pointer" }}
            className="pi pi-ellipsis-v"
            onClick={(event) => {
              menu.current.toggle(event);
            }}
          ></i>
        </>
      );
    };
    return (
        <div style={{ margin: "2rem" }}>
              <Toast ref={toast} className="ToastMessage" />
              <div className="grid mr-5">
                
                <div className="col-12" >
                  <div className="bannerStyle " style={{textAlign:"start"}}>Life Event</div>
                </div>
               
              </div>
              <div className="col-12" style={{textAlign:"end"}}>
                  <Button
                    type="button"
                    label="Add Event"
                    className="p-button-raised p-button-warning mr-4"
                    onClick={handleLifeEventModal}
                  />
                </div>
              <DataTable
                value={lifeEvents}
                className="propertyTable mt-3"
                responsiveLayout="scroll"
                emptyMessage="Please add your event details."
                scrollHeight="600px"
                scrollDirection="both"
                rows={10}
                loading={isLoading}
                paginator={lifeEvents.length > 10}
                rowHover
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink   CurrentPageReport"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              >
               
                <Column
                  sortable
                  field="eventname"
                  header="Event Name"
                  body={linkTemplate} 
                  
                />
                <Column field="plannedDate" body={planneddateTemplate} header="Planned Date" />
               
                <Column field="Actions" body={actionTemplate} header="Actions" />
              </DataTable>
              {lifeEventModal && renderLifeEventModal()}
            </div>
    );

};

export default LifeEvents;